import React from 'react';
import { ClipboardCheckIcon, FileSpreadsheetIcon, LightbulbIcon, PaletteIcon, RulerIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { BONUS_VALUE, bonuses } from '../data/content';
const ICONS = {
  palette: PaletteIcon,
  sheet: FileSpreadsheetIcon,
  ruler: RulerIcon,
  bulb: LightbulbIcon,
  checklist: ClipboardCheckIcon
};

/* Colores de cada bono, siguiendo la paleta del pack */
const BONUS_COLORS = ['bg-party-rose text-white', 'bg-party-gold text-party-ink', 'bg-party-brown text-white', 'bg-party-pastel text-party-ink', 'bg-party-ink text-party-gold'];
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="bg-party-cream text-party-ink" data-id="element-27" data-mp="1elgned8l8lxc">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-28" data-mp="19ksybx3x6f5r">
        <h2 id="bonos" className="font-display text-xl font-black leading-tight sm:text-3xl" data-id="element-29" data-mp="1nl3thcc9ifwq">
          <span className="bg-party-rose px-2 text-white" data-id="element-30" data-mp="1jk1oeevnz9mu">5 Bonos incluidos</span>
        </h2>
        <p className="mx-auto mt-1.5 max-w-xl text-[0.8rem] font-medium leading-snug text-party-ink/75" data-id="element-31" data-mp="3prwkksfjfzur">
          Y además recibes 5 recursos prácticos — GRATIS con tu compra.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-32" data-mp="2kul2nbt819j">
          {bonuses.map((bono, i) => {
          const Icon = ICONS[bono.icon];
          return <Reveal key={bono.title} as="li" delay={i * 0.03} className="flex h-full flex-col overflow-hidden rounded-lg border-2 border-party-pastel bg-white text-left" data-id="element-33" data-mp="ck1tcw3ot5ps" data-mpi={i}>
                <span className={`flex items-center gap-1.5 px-2.5 py-1 font-sans text-[0.62rem] font-extrabold uppercase tracking-[0.1em] ${BONUS_COLORS[i]}`} data-id="element-34" data-mp="lcvq67f6gnre">
                  <Icon size={12} aria-hidden="true" data-id="element-35" data-mp="vbumqrmo4sy1" />
                  Bono {i + 1} — Gratis
                </span>
                <div className="flex flex-1 flex-col p-2.5" data-id="element-36" data-mp="107a2xq85f0xm">
                  <h3 className="font-sans text-[0.8rem] font-extrabold uppercase leading-tight" data-id="element-37" data-mp="am0jscm7m166">
                    {bono.title}
                  </h3>
                  <p className="mt-0.5 text-[0.74rem] leading-snug text-party-ink/75" data-id="element-38" data-mp="kb1ze1ouegjm">
                    {bono.desc}
                  </p>
                  <p className="mt-auto pt-1 font-sans text-sm font-bold uppercase tracking-wide text-party-ink/55 line-through decoration-party-rose decoration-2" data-id="element-39" data-mp="fjafub43tb2z">
                    {bono.value}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>

        <div className="mt-3 inline-block rounded-lg border-2 border-dashed border-party-rose bg-white px-3 py-2 font-sans text-[0.78rem] font-extrabold uppercase leading-tight sm:text-sm" data-id="element-40" data-mp="138uysu09c8c9">
          <p data-id="element-41" data-mp="352asy0vk05bz">💰 Valor total de los 5 bonos: {BONUS_VALUE}</p>
          <p className="mt-0.5 text-party-rose" data-id="element-42" data-mp="3026ba7iwt4k6">
            🔥 Hoy los 5 están incluidos gratis.
          </p>
        </div>
      </div>
    </section>;
}